// Visibility for this client build; account permissions and features stay intact.
export const CLIENT_UI = {
  showContactSocialProfiles: false,
  hiddenSidebarGroups: ['Captain', 'Companies', 'Calls'],
  hiddenCommandRoutes: ['captain_assistants_index', 'calls_dashboard_index'],
  hiddenSidebarRoutes: {
    Reports: ['sla_reports'],
    Settings: [
      'auditlogs_list',
      'custom_roles_list',
      'sla_list',
      'security_settings_index',
      'assignment_policy_index',
      'billing_settings_index',
      'settings_templates',
    ],
  },
};
